module.exports = __webpack_public_path__ + "img/doc-flow-logo.8f00c598.svg";